import { addHours } from 'date-fns'

/**
 * Get cookie by name
 * @param name - Name of the cookie
 * @returns The value of the cookie or undefined if not found
 */
export function getCookie(name: string): string | undefined {
  const matches = document.cookie.match(
    new RegExp(
      `(?:^|; )${name.replace(
        /([.$?*|{}()[]\/+^])/g,
        '\\$1'
      )}=([^;]*)`
    )
  )
  return matches ? decodeURIComponent(matches[1]) : undefined
}

const stringifyValue = (val: string | Record<string, unknown>): string =>
  typeof val === 'string' ? val : JSON.stringify(val)

const bakeSessionCookie = (name: string, value: string | Record<string, unknown>, resolve: (value: boolean) => void): void => {
  const cookie = [name, '=', stringifyValue(value), ';expires=Session', '; path=/;'].join('')
  document.cookie = cookie
  resolve(true)
}

const bakeCookie = (name: string, value: string | Record<string, unknown>, hours: number): void => {
  let date = new Date()
  date = addHours(date, hours)
  const cookie = [name, '=', stringifyValue(value), ';expires', '=', date.toUTCString(), '; path=/;'].join('')
  document.cookie = cookie
}

const ONE_MONTH_HOURS_COUNT = 30 * 1 * 24

/**
 * Set a session cookie (without an expiration date)
 * @param name - Name of the cookie
 * @param val - Value of the cookie
 * @returns A promise that resolves to true when the cookie is set
 */
export function setSessionCookie(name: string, val: string | Record<string, unknown>): Promise<boolean> {
  return new Promise((resolve, reject) => {
    bakeSessionCookie(name, val, resolve)
  })
}

/**
 * Clear a cookie by setting its expiration date to the past
 * @param name - Name of the cookie
 */
export function clearCookie(name: string): void {
  bakeCookie(name, '', -1)
}

// Uncomment this function if you need to set a cookie with an expiration date

/**
 * Set a cookie with an expiration date
 * @param name - Name of the cookie
 * @param val - Value of the cookie
 * @param hours - Expiration time in hours
//  */
export function setCookie(name: string, val: string | Record<string, unknown>, hours = ONE_MONTH_HOURS_COUNT): void {
  bakeCookie(name, val, hours)
}
